import { Component, Input } from '@angular/core'
import { Customer } from 'src/types'

@Component({
  selector: 'empty-customer-pending',
  template: `
    <div class="text-center bottom-buffer empty-state">
      <i class="far fa-credit-card"></i>
      <h3 class="mt-2">We need more information to start your subscription for {{ customer.businessName }}.</h3>

      Click below to finish building your plan:
      <div class="top-buffer">
        <a [routerLink]="['/dashboard', customer.id, 'plan']" class="orange-button">Complete Signup</a>
      </div>

    </div>
  `
})
export class EmptyCustomerPendingComponent {
  @Input() customer: Customer;
}
